<template>
  <div class="site-loader" aria-live="polite" aria-busy="true">
    <div class="site-loader__content">
      <img :src="logoGs" alt="GS" class="site-loader__logo" loading="eager" fetchpriority="high">
      <div class="spinner-border text-light site-loader__spinner" role="status" aria-label="Cargando">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>
  </div>
</template>

<script>
import logoGs from '@/assets/logos/logo_black.svg'

export default {
  name: 'SiteLoader',
  data() {
    return { logoGs }
  },
  mounted() {
    document.body.classList.add('no-scroll')
  },
  beforeUnmount() {
    document.body.classList.remove('no-scroll')
  },
}
</script>
